import { NoteEntityId } from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { ActivityEntityType } from "components/entity-activity/types";
import React from "react";
import { Header } from "../header";
import { ModernNotes } from "./modern-notes";

interface NotesProps {
    entityId: NoteEntityId;
    entityType?: ActivityEntityType;
    onChanged?: () => void;
}

export const Notes: React.FC<NotesProps> = props => {
    const { entityId, entityType, onChanged } = props;
    return (
        <InputFormBlock additionalClassName="overflow-y-scroll max-h-128">
            <Header iconName="09_Notes">Notes</Header>
            <ModernNotes
                entityId={entityId}
                entityType={entityType}
                onChanged={onChanged}
            />
        </InputFormBlock>
    );
};
